import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
} from "@mui/material";
import CustomButton from "../Button/CustomButton";
import Searchbar from "../Searchbar/Searchbar";
import { SearchDebouncing } from "../../APIs/Search/SearchDebouncing";
import SelectRecipeTable from "../Table/SelectRecipe";
import { GetRecipe } from "../../APIs/Function/Workout/Recipe/GetRecipe";

const SelectRecipeModal = ({
  recipeType,
  setRecipeType,
  tempRecipe,
  setTempRecipe,
  onSelectRecipes,
  open,
  onClose,
  searchTerm,
  setSearchTerm,
  loading,
  setLoading,
  setSelectedRecipeData = { setSelectedRecipeData },
  selectedRecipeData = { selectedRecipeData },
}) => {
  const [recipeData, setRecipeData] = useState([]);

  const handleRecipe = async () => {
    try {
      let res = await GetRecipe();
      console.log(res.r);
      setRecipeData(res.r);
    } catch (error) {}
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      await SearchDebouncing(5, searchTerm, setRecipeData, recipeType);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSaveButtonClick = () => {
    // Reset selectedRecipeData to an empty array
    setTempRecipe(selectedRecipeData);

    const checkedRecipes = recipeData.filter((recipe) =>
      selectedRecipeData.some(
        (selectedRecipe) => selectedRecipe.id === recipe.id
      )
    );
    onSelectRecipes(checkedRecipes);
    setRecipeType(4);
    setSelectedRecipeData([]);
    onClose();
  };

  useEffect(() => {
    handleRecipe();
  }, []);

  useEffect(() => {
    handleSearch();
  }, [searchTerm, recipeType]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Box
          sx={{
            width: "80%",
            height: "70%",
            position: "relative",
            outline: "none",
            backgroundColor: "white",
            boxShadow: 24,

            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ p: 2 }}>
            <Typography
              sx={{
                fontFamily: "Open Sans",
                fontWeight: 600,
                fontSize: "21px",
              }}
            >
              Select Recipes
            </Typography>
            <Box sx={{ display: "flex", gap: "10px", mt: "10px" }}>
              <Box sx={{ width: "65%" }}>
                <Searchbar
                  placeholder={"Search"}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Box>

              <Box sx={{ width: "35%" }}>
                <Grid item xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel
                      sx={{ bgcolor: "#fff" }}
                      htmlFor="recipe-type-select"
                    >
                      Recipe Type
                    </InputLabel>
                    <Select
                      name="recipe_type"
                      value={recipeType}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        setRecipeType(selectedValue); // Update the recipeType state
                        handleSearch(selectedValue); // Call the search function with the selected value
                      }}
                      sx={{
                        textAlign: "left",
                      }}
                    >
                      <MenuItem value={1}>Morning</MenuItem>
                      <MenuItem value={2}>Afternoon</MenuItem>
                      <MenuItem value={3}>Evening</MenuItem>
                      <MenuItem value={4}>Anytime</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              flex: 1,
              mt: "-30px",
              boxSizing: "border-box",
              p: 2,
              overflow: "auto",
            }}
          >
            <SelectRecipeTable
              selectedRecipeData={selectedRecipeData}
              setSelectedRecipeData={setSelectedRecipeData}
              setRecipeData={setRecipeData}
              RecipeData={recipeData}
              loadinga={loading}
              Column1={"#"}
              Column2={"photo"}
              column3={"title"}
              Column4={"status"}
              tempRecipe={tempRecipe}
              loading={loading}
              setLoading={setLoading}
            />
          </Box>

          <Box
            sx={{
              height: "60px",
              bgcolor: "#E8E8E8",
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              p: 2,
              boxSizing: "border-box",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "5px",
                width: "50%",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <CustomButton
                sx={{
                  width: "25%",
                  bgcolor: "#D0D0D0",
                  color: "#000000",
                  "&:hover": {
                    background: "#D0D0D0",
                  },
                }}
                onClick={onClose}
              >
                Cancel
              </CustomButton>
              <CustomButton
                sx={{
                  width: "25%",
                  bgcolor: "#31AEF4",
                  "&:hover": {
                    background: "#31AEF4",
                  },
                }}
                onClick={handleSaveButtonClick}
              >
                Save
              </CustomButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default SelectRecipeModal;
